<template>
  <section class="page-center space-pt-4 type-align-center type-align-left--s grid | home-hero">
    <div class="default-hero__circle-picture" />

    <div class="grid__row grid__row--end">
      <div class="grid__col-12--xxs grid__col-10--s grid__col-right--s space-pt-4 space-pt-0--s" />
      <div class="grid__col-12--xxs grid__col-10--s space-pb-10--s space-pt-5--s space-pl-0">
        <!-- eslint-disable vue/no-v-html -->
        <h2 class="type-title-primary type-weight-700 space-mb-3" v-html="title" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DefaultHero',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  // This is a copy of .home-hero__circle-picture from Hero component
  .default-hero__circle-picture {
    position: absolute;
    top: 0;
    left: 50%;
    width: 150%;
    height: 0;
    padding-top: 150%;
    background-color: c('grey');
    border-radius: 50%;
    opacity: 0.8;
    transform: translate(-50%, -40%);

    @media #{media('xs')} {
      transform: translate(-50%, -45%);
    }

    @media #{media('s')} {
      top: unset;
      right: -50%;
      bottom: 10%;
      left: unset;
      width: 100%;
      padding-top: 100%;
      transform: unset;
    }

    @media #{media('m')} {
      right: -40%;
      bottom: 10%;
      width: 60rem;
      height: 60rem;
      padding-top: 0;
    }
  }
</style>
